export default __webpack_public_path__ + "static/media/partner5.ca44203b.webp";